(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DecisioneSearch', DecisioneSearch);

    DecisioneSearch.$inject = ['$resource'];

    function DecisioneSearch($resource) {
        var resourceUrl =  'api/_search/decisiones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
